<template>
  <Container padding-top :class="$style['page']">
    <!-- The title and the way out stay in view next to the questions -->
    <div :class="$style['intro']">
      <SitePageTitle title="Veelgestelde vragen" :class="$style['title']">
        Alles wat je wilt weten over de Hengelose Revue, van kaartjes kopen tot kostuums huren.
      </SitePageTitle>
      <div :class="$style['cta']">
        <p>Staat je vraag er niet bij?</p>
        <Button to="/contact" color="cta">
          Neem contact op
        </Button>
      </div>
    </div>

    <div :class="$style['faq']">
      <details v-for="faq in faqs" :key="faq.question" :class="$style['faq__item']">
        <summary :class="$style['faq__question']">
          {{ faq.question }}
        </summary>
        <div :class="$style['faq__answer']" v-html="faq.answerHtml" />
      </details>
    </div>

  </Container>
</template>

<script setup>
const { formatDefault, formatFaq, formatBreadcrumbs } = useHrMeta()

const faqs = [
  {
    question: 'Hoeveel kost een kaartje voor de Hengelose Revue?',
    answer: 'Een kaartje voor de Hengelose Revue kost €21,50. Kaartjes zijn te koop via Schouwburg Hengelo. Wij spelen jaarlijks meerdere voorstellingen in januari en februari, zodat je altijd een datum kunt vinden die uitkomt.',
    answerHtml: 'Een kaartje voor de Hengelose Revue kost <strong>€21,50</strong>. Kaartjes zijn te koop via <a href="https://www.schouwburghengelo.nl/" target="_blank" rel="noopener">Schouwburg Hengelo</a>. Wij spelen jaarlijks meerdere voorstellingen in januari en februari, zodat je altijd een datum kunt vinden die uitkomt.'
  },
  {
    question: 'Waar vinden de voorstellingen plaats?',
    answer: 'De voorstellingen van de Hengelose Revue worden gehouden in Schouwburg Hengelo, aan de Beursstraat 44 in Hengelo. Schouwburg Hengelo is gemakkelijk bereikbaar per auto en openbaar vervoer en beschikt over voldoende parkeergelegenheid in de directe omgeving.',
    answerHtml: 'De voorstellingen van de Hengelose Revue worden gehouden in <strong>Schouwburg Hengelo</strong>, aan de Beursstraat 44 in Hengelo. Schouwburg Hengelo is gemakkelijk bereikbaar per auto en openbaar vervoer en beschikt over voldoende parkeergelegenheid in de directe omgeving.'
  },
  {
    question: 'Wanneer zijn de voorstellingen?',
    answer: 'De Hengelose Revue speelt jaarlijks in januari en februari. De exacte data en tijden per seizoen vind je op de kaartverkoop-pagina zodra deze beschikbaar zijn. Houd onze nieuwspagina en sociale media in de gaten voor aankondigingen van het nieuwe seizoen.',
    answerHtml: 'De Hengelose Revue speelt jaarlijks in <strong>januari en februari</strong>. De exacte data en tijden per seizoen vind je op de <a href="/kaartverkoop">kaartverkoop-pagina</a> zodra deze beschikbaar zijn. Houd onze nieuwspagina en sociale media in de gaten voor aankondigingen van het nieuwe seizoen.'
  },
  {
    question: 'Hoe lang bestaat de Hengelose Revue al?',
    answer: 'De Hengelose Revue bestaat al sinds 1953. De organisatie is opgericht vanuit voetbalvereniging Hengelo en heeft zich in de loop der jaren ontwikkeld tot een professionele amateurtheatervereniging. Inmiddels brengen we al meer dan 70 jaar jaarlijks een originele komedie revue op de planken in Twente.',
    answerHtml: 'De Hengelose Revue bestaat al sinds <strong>1953</strong>. De organisatie is opgericht vanuit voetbalvereniging Hengelo en heeft zich in de loop der jaren ontwikkeld tot een professionele amateurtheatervereniging. Inmiddels brengen we al meer dan 70 jaar jaarlijks een originele komedie revue op de planken in Twente.'
  },
  {
    question: 'Is de Hengelose Revue geschikt voor kinderen?',
    answer: 'De Hengelose Revue is geschikt voor vrijwel alle leeftijden, vanaf circa 12 jaar. De voorstellingen bestaan uit komedie, live muziek en dans met toegankelijke humor. Jongere kinderen kunnen de voorstelling ook bijwonen, maar houd er rekening mee dat de avondshow relatief laat eindigt.',
    answerHtml: 'De Hengelose Revue is geschikt voor vrijwel alle leeftijden, <strong>vanaf circa 12 jaar</strong>. De voorstellingen bestaan uit komedie, live muziek en dans met toegankelijke humor. Jongere kinderen kunnen de voorstelling ook bijwonen, maar houd er rekening mee dat de avondshow relatief laat eindigt.'
  },
  {
    question: 'Kan ik kostuums of decor huren bij de Hengelose Revue?',
    answer: 'Ja, de Hengelose Revue verhuurt theaterkostuums en themakleding aan particulieren en bedrijven. Het verhuurassortiment omvat onder andere carnavalskleding, musical- en theateroutfits en diverse themakleding. Kijk op onze verhuurtpagina voor het volledige aanbod, of neem contact op via kleding@hengeloserevue.nl voor meer informatie en beschikbaarheid.',
    answerHtml: 'Ja, de Hengelose Revue verhuurt theaterkostuums en themakleding aan particulieren en bedrijven. Het verhuurassortiment omvat onder andere carnavalskleding, musical- en theateroutfits en diverse themakleding. Kijk op onze <a href="/verhuur">verhuurpagina</a> voor het volledige aanbod, of neem contact via <a href="mailto:kleding@hengeloserevue.nl">kleding@hengeloserevue.nl</a> voor meer informatie en beschikbaarheid.'
  },
  {
    question: 'Hoe kan ik contact opnemen met de Hengelose Revue?',
    answer: 'Je kunt ons bereiken via het contactformulier op onze website, per e-mail via secretariaat@hengeloserevue.nl of per telefoon op 074 291 8579. Ons kantoor is gevestigd aan de Torenlaan 53 in Hengelo (7559 PK). We reageren zo snel mogelijk op alle vragen en berichten.',
    answerHtml: 'Je kunt ons bereiken via het <a href="/contact">contactformulier</a> op onze website, per e-mail via <a href="mailto:secretariaat@hengeloserevue.nl">secretariaat@hengeloserevue.nl</a> of per telefoon op <a href="tel:+31742918579">074 291 8579</a>. Ons kantoor is gevestigd aan de Torenlaan 53 in Hengelo (7559 PK). We reageren zo snel mogelijk op alle vragen en berichten.'
  },
  {
    question: 'Hoe kan ik sponsor worden van de Hengelose Revue?',
    answer: 'We bieden verschillende sponsorpakketten aan voor bedrijven die de Hengelose Revue willen ondersteunen. Als sponsor profiteer je van naamsvermelding in het programmaboekje, op onze website en op sociale media. Neem contact op met Henk Kiewik via sponsoring@hengeloserevue.nl of bekijk onze sponsoringpagina voor meer informatie over de mogelijkheden.',
    answerHtml: 'We bieden verschillende sponsorpakketten aan voor bedrijven die de Hengelose Revue willen ondersteunen. Als sponsor profiteer je van naamsvermelding in het programmaboekje, op onze website en op sociale media. Neem contact op met Henk Kiewik via <a href="mailto:sponsoring@hengeloserevue.nl">sponsoring@hengeloserevue.nl</a> of bekijk onze <a href="/sponsoring">sponsoringpagina</a> voor meer informatie over de mogelijkheden.'
  }
]

formatDefault()
formatFaq({
  title: 'Veelgestelde vragen',
  description: 'Antwoorden op de meestgestelde vragen over de Hengelose Revue: kaartjes, voorstellingen, kostuumverhuur en meer.',
  faqs: faqs.map(({ question, answer }) => ({ question, answer }))
})
formatBreadcrumbs()
</script>

<style module>
/* Title on the left, questions on the right */
.page {
  display: grid;
  grid-template-columns: minmax(0, 5fr) minmax(0, 7fr);
  align-items: start;
  gap: var(--spacing-xxl) clamp(2.5rem, 1rem + 4vw, 6rem);
}

.intro {
  position: sticky;
  top: calc(var(--topbar-height) + var(--spacing-xl));
  display: grid;
  gap: var(--spacing-xl);
}

.title {
  margin-bottom: 0;
}

/* Questions as hairline rows, like the dates on the homepage */
.faq {
  border-bottom: var(--stage-hairline) solid var(--stage-line);
}

.faq__item {
  border-top: var(--stage-hairline) solid var(--stage-line);
}

.faq__question {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-xl);
  padding: var(--spacing-xl) 0;
  font-family: var(--font-family-heading);
  font-weight: var(--font-weight-bold);
  font-size: clamp(1.0625rem, 0.95rem + 0.5vw, 1.375rem);
  line-height: 1.1;
  letter-spacing: -0.015em;
  text-transform: uppercase;
  list-style: none;
  cursor: pointer;
  user-select: none;
  transition: color 200ms;
}

.faq__question:hover {
  color: var(--primary-color);
}

.faq__question::-webkit-details-marker {
  display: none;
}

.faq__question::after {
  content: "+";
  display: grid;
  place-items: center;
  flex: none;
  width: 2.5rem;
  height: 2.5rem;
  border: 0.125rem solid currentcolor;
  border-radius: 50%;
  font-family: var(--font-family);
  font-size: var(--font-size-large);
  font-weight: var(--font-weight-normal);
  transition: transform 300ms var(--stage-ease), background-color 200ms, color 200ms;
}

.faq__item[open] .faq__question::after {
  background: var(--primary-color);
  border-color: var(--primary-color);
  color: var(--stage-black);
  transform: rotate(45deg);
}

.faq__answer {
  max-width: var(--stage-measure);
  padding: 0 0 var(--spacing-xxl);
  font-size: var(--stage-text);
  line-height: 1.65;
  color: var(--stage-soft);
}

.faq__answer :where(strong) {
  color: var(--stage-white);
}

.faq__answer a {
  color: var(--primary-color);
  text-underline-offset: 0.2em;
}

.cta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--spacing-l) var(--spacing-xl);
}

.cta p {
  margin: 0;
  font-size: var(--stage-text);
}

@media (width <= 56rem) {
  .page {
    grid-template-columns: minmax(0, 1fr);
  }

  .intro {
    position: static;
  }
}

@media (prefers-reduced-motion: reduce) {
  .faq__question,
  .faq__question::after {
    transition: none;
  }
}
</style>
